import { useMemo } from 'react';
import { useUserPermissions } from 'entities/user';

export const useCarLimitationsVisibility = () => {
  const permissions = useUserPermissions();

  return useMemo(() => ({
    buildingRouteFilter: !!permissions.buildingRouteVehicleTypeSelect,
    stationsFilter: !!permissions.servicePointFilterVehicleTypeSelect
  }), [permissions]);
};
